import React, { useContext } from 'react';
import { Card, Title, Text, Button } from 'components';
import styled from 'styled-components';
import ManageListingsContext from './ManageListingsContext';

const EnableToggleCard = () => {
  const { openModal, totalCount, enabledCount } = useContext(
    ManageListingsContext,
  );

  const enableHandler = () => {
    openModal('enableListings');
  };

  const disableHandler = () => {
    openModal('disableListings');
  };

  return (
    <StyledCard>
      <Title level={2} data-cy={`listing-toggle-title`}>
        Which listings would you like to enable
      </Title>
      <StyledListChild
        data-enabled-count={enabledCount}
        data-total-count={totalCount}
      >{`${enabledCount} of ${totalCount} active listings enabled`}</StyledListChild>
      <StyledToggleContainer>
        <Button
          type="link"
          onClick={enableHandler}
          data-cy="listings-enable-all"
        >
          Enable all
        </Button>
        <Text type="secondary">|</Text>
        <Button
          type="link"
          onClick={disableHandler}
          data-cy="listings-disable-all"
        >
          Disable all
        </Button>
      </StyledToggleContainer>
      <StyledText
        type="secondary"
        textAlign="center"
        data-cy="listings-toggle-text"
      >
        Enable or disable all listings or select the listings you would like to
        enable below. You can disable them later
      </StyledText>
    </StyledCard>
  );
};

export default EnableToggleCard;

const StyledCard = styled(Card)`
  gridcolumn: 1;
  & > div {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }
  padding: 0 5%;
`;

const StyledListChild = styled(Text)`
  &::before {
    content: '• ';
    color: #52c41a;
  }
`;

const StyledText = styled(Text)`
  font-size: 14px;
`;

const StyledToggleContainer = styled.div``;
